import { Get , Post} from "../../utils/http-utils";
export const getTrackDeploymentsList = async (Params) => {
  return Get("/scm/package/deploy/all", Params)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getDeploymentDetails = async (Params) => {
  return Get("/scm/package/deploy", Params)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const cancelDeployment = async (jsonPayload) => {
  return Post("/scm/package/deploy/cancel", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });

}

